
import type { SxProps, Theme } from "@mui/material/styles";
import { Iconify } from "@/lib/iconify";
import { UI_ICONS } from "@/lib/ui-icons";

export const BLYN_ICON_NAMES: Record<string, string> = {
  // ── Blyn-specific (Solar linear set) ──────────────────────────────────
  alert:         "solar:danger-triangle-linear",
  approvals:     "solar:check-circle-linear",
  askblyn:       "solar:sparkles-linear",
  arrow:         "solar:alt-arrow-right-linear",
  back:          "solar:alt-arrow-left-linear",
  bell:          "solar:bell-linear",
  book:          "solar:book-2-linear",
  check:         "solar:check-read-linear",
  clock:         "solar:clock-circle-linear",
  journey:       "solar:route-linear",
  layers:        "solar:layers-linear",
  link:          "solar:link-linear",
  message:       "solar:chat-line-linear",
  menu:          "solar:hamburger-menu-linear",
  "more-vertical": "mdi:dots-vertical",
  notifications: "solar:notification-unread-linear",
  pause:         "solar:pause-linear",
  pencil:        "solar:pen-linear",
  pin:           "solar:pin-linear",
  play:          "solar:play-circle-linear",
  plus:          "solar:add-circle-linear",
  question:      "solar:question-circle-linear",
  sidebarCollapse: "lucide:sidebar-close",
  sidebarExpand:   "lucide:sidebar-open",
  globe:         "solar:global-linear",
  mail:          "solar:letter-linear",
  package:       "solar:box-linear",
  staged:        "solar:layers-linear",
  trending:      "solar:chart-2-linear",
  zap:           "solar:bolt-linear",

  // ── Shared with cloudfront_ui (from UI_ICONS) ─────────────────────────
  add:           UI_ICONS.add,
  archive:       UI_ICONS.archive,
  calendar:      UI_ICONS.calendar,
  close:         UI_ICONS.close,
  copy:          UI_ICONS.copy,
  download:      UI_ICONS.download,
  duplicate:     UI_ICONS.duplicate,
  edit:          UI_ICONS.edit,
  delete:        UI_ICONS.delete,
  filter:        UI_ICONS.filter,
  folder:        UI_ICONS.folder,
  fullscreen:    UI_ICONS.fullscreen,
  fullscreenExit: UI_ICONS.fullscreenExit,
  help:          UI_ICONS.help,
  location:      UI_ICONS.location,
  more:          UI_ICONS.moreHoriz,
  refresh:       UI_ICONS.refresh,
  search:        UI_ICONS.search,
  send:          UI_ICONS.send,
  settings:      UI_ICONS.settings,
  share:         UI_ICONS.share,
  upload:        UI_ICONS.upload,
  user:          UI_ICONS.user,
  users:         UI_ICONS.users,
  view:          UI_ICONS.view,

  grid:          "solar:widget-4-linear",
  list:          "solar:list-linear",

  // --- New mappings ---
  closeLine:           UI_ICONS.closeLine,
  addCircle:           UI_ICONS.addCircle,
  arrowDown:           UI_ICONS.arrowDown,
  arrowLeft:           UI_ICONS.arrowLeft,
  arrowRight:          UI_ICONS.arrowRight,
  arrowRightLinear:    UI_ICONS.arrowRightLinear,
  bellLinear:          UI_ICONS.bellLinear,
  boltLinear:          UI_ICONS.boltLinear,
  bookLinear:          UI_ICONS.bookLinear,
  brainLinear:         UI_ICONS.brainLinear,
  chatDots:            UI_ICONS.chatDots,
  chatLine:            UI_ICONS.chatLine,
  checkCircleLinear:   UI_ICONS.checkCircleLinear,
  checkRead:           UI_ICONS.checkRead,
  checkSquare:         UI_ICONS.checkSquare,
  clapperboard:        UI_ICONS.clapperboard,
  clockCircle:         UI_ICONS.clockCircle,
  closeCircle:         UI_ICONS.closeCircle,
  dangerTriangle:      UI_ICONS.dangerTriangle,
  documentText:        UI_ICONS.documentText,
  downloadLinear:      UI_ICONS.downloadLinear,
  folderLinear:        UI_ICONS.folderLinear,
  folderWithFiles:     UI_ICONS.folderWithFiles,
  history:             UI_ICONS.history,
  layersLinear:        UI_ICONS.layersLinear,
  pauseLinear:         UI_ICONS.pauseLinear,
  pencil2:             UI_ICONS.pencil2,
  pencilLinear:        UI_ICONS.pencilLinear,
  pinLinear:           UI_ICONS.pinLinear,
  questionCircle:      UI_ICONS.questionCircle,
  restart:             UI_ICONS.restart,
  rocket:              UI_ICONS.rocket,
  routeLinear:         UI_ICONS.routeLinear,
  settingsSolar:       UI_ICONS.settingsSolar,
  shareSolar:          UI_ICONS.shareSolar,
  uploadSolar:         UI_ICONS.uploadSolar,
  usersGroupTwoLinear: UI_ICONS.usersGroupTwoLinear,
};

export function BlynIcon({
  name,
  size = 14,
  className,
  sx,
}: {
  name?: string;
  size?: number;
  className?: string;
  sx?: SxProps<Theme>;
}) {
  return (
    <Iconify
      icon={BLYN_ICON_NAMES[name || ""] || BLYN_ICON_NAMES.message}
      width={size}
      className={className}
      sx={sx}
    />
  );
}
